import { useGetList } from "ra-core";
import { useMemo } from "react";

import type { TagSummary } from "../types";

/** All tags, the most used first (then alphabetically). */
export const useTagsByUsage = () => {
  const { data = [], refetch } = useGetList<TagSummary>("tags_summary", {
    pagination: { page: 1, perPage: 1000 },
    sort: { field: "name", order: "ASC" },
  });
  const tags = useMemo(
    () =>
      [...data].sort(
        (a, b) =>
          (b.nb_contacts ?? 0) - (a.nb_contacts ?? 0) ||
          a.name.localeCompare(b.name),
      ),
    [data],
  );
  return { tags, refetch };
};
